import { PreSalesBookingLanes, PreSalesQuestion } from '../dto/model';

// LEAD-409: temporary exclusion of PV from the unified flow. See docs/unified-flow-pv.md.
export const TEMPORARILY_ENABLE_UNIFIED_PRE_SALES_PV = false;

export const isUnifiedPreSalesProductEnabled = (product: string): boolean =>
  TEMPORARILY_ENABLE_UNIFIED_PRE_SALES_PV || product.toUpperCase() !== 'PV';

const PV_LANES: string[] = [PreSalesBookingLanes.PvVideo, PreSalesBookingLanes.PvHpVideo];

/**
 * The products each lane books, mirroring the backend `BookingLanes.ProductsFor`. A lane is only offered
 * when every product it books is enabled, so excluding a product also excludes the lanes that need it.
 */
const LANE_PRODUCTS: Record<string, string[]> = {
  [PreSalesBookingLanes.HpVideo]: ['HP'],
  [PreSalesBookingLanes.HpInVideo]: ['HP', 'IN'],
  [PreSalesBookingLanes.InVideo]: ['IN'],
  [PreSalesBookingLanes.PvVideo]: ['PV'],
  [PreSalesBookingLanes.HpHv]: ['HP'],
  [PreSalesBookingLanes.PvHpVideo]: ['HP', 'PV'],
  [PreSalesBookingLanes.HpVideoOverbooking]: ['HP'],
};

export const isUnifiedPreSalesBookingLaneEnabled = (lane: string): boolean => {
  // A lane the UI does not know about is left to the backend to gate; only known lanes are filtered here.
  const products = LANE_PRODUCTS[lane];
  if (!products) {
    return !PV_LANES.includes(lane);
  }

  return products.every(isUnifiedPreSalesProductEnabled);
};

export const isUnifiedPreSalesQuestionEnabled = (question: PreSalesQuestion): boolean => {
  if (TEMPORARILY_ENABLE_UNIFIED_PRE_SALES_PV) return true;
  const products = question.products ?? (question.product ? [question.product] : []);
  return products.length === 0 || products.some(isUnifiedPreSalesProductEnabled);
};
